module.exports = __webpack_public_path__ + "media/spring_tip_4-8b424a6a6c567456600f42d332addd92.mp3";